export class CategoryDataRecord {
    public categoryId: number;
    public subCategoryId: number;
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/app/models/categorydatarecord.ts